var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#DCFAE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19H19.5C18.837 19 18.2011 18.7366 17.7322 18.2678C17.2634 17.7989 17 17.163 17 16.5C17 15.837 17.2634 15.2011 17.7322 14.7322C18.2011 14.2634 18.837 14 19.5 14C23 14 24 19 24 19ZM24 19H28.5C29.163 19 29.7989 18.7366 30.2678 18.2678C30.7366 17.7989 31 17.163 31 16.5C31 15.837 30.7366 15.2011 30.2678 14.7322C29.7989 14.2634 29.163 14 28.5 14C25 14 24 19 24 19ZM24 19L24 34M14 26H34M14 22.2L14 30.8C14 31.9201 14 32.4802 14.218 32.908C14.4097 33.2843 14.7157 33.5903 15.092 33.782C15.5198 34 16.0799 34 17.2 34L30.8 34C31.9201 34 32.4802 34 32.908 33.782C33.2843 33.5903 33.5903 33.2843 33.782 32.908C34 32.4802 34 31.9201 34 30.8V22.2C34 21.0799 34 20.5198 33.782 20.092C33.5903 19.7157 33.2843 19.4097 32.908 19.218C32.4802 19 31.9201 19 30.8 19L17.2 19C16.0799 19 15.5198 19 15.092 19.218C14.7157 19.4097 14.4097 19.7157 14.218 20.092C14 20.5198 14 21.0799 14 22.2Z",
    stroke: "#079455",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift-icon.b733f0074b90cdaf59a11092aebac363.svg";
export { ForwardRef as ReactComponent };